import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { array, func } from 'prop-types';
import { translate } from 'react-i18next';

import {
  FacebookIcon,
  EmailIcon,
  TwitterIcon,
  LineIcon,
  ExternalLink,
} from '@snapask/common-components';
import LikeBlock from './components/LikeBlock';

import { getSocials } from '@blueberry/redux/socialMedia';

import styles from './SocialMedia.scss';

const mapStateToProps = state => ({
  socials: getSocials(state),
});

class SocialMedia extends Component {
  static propTypes = {
    socials: array.isRequired,
    t: func.isRequired,
  };

  Facebook = t => {
    const currentUrl = window.location.href;
    const onClickFacebookShare = () => {
      window.FB.ui({
        method: 'share',
        quote: `${t('content.shareContent')}`,
        href: currentUrl,
      });
    };

    return (
      <div
        key="Facebook"
        className={styles.icon}
        onClick={onClickFacebookShare}
      >
        <a className="fb-xfbml-parse-ignore">
          <FacebookIcon width={16} height={16} />
        </a>
      </div>
    );
  };

  Email = t => {
    const currentUrl = encodeURIComponent(window.location.href);
    const shareUrl = `mailto:?subject=${encodeURIComponent(
      t('content.mailToSubject')
    )}&body=${t('content.shareContent')} ${currentUrl}`;

    return (
      <div className={styles.icon} key="Email">
        <ExternalLink href={shareUrl}>
          <EmailIcon width={16} height={16} />
        </ExternalLink>
      </div>
    );
  };

  Twitter = t => {
    const currentUrl = encodeURIComponent(window.location.href);
    const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      t('content.shareContent')
    )}&url=${currentUrl}`;

    return (
      <div className={styles.icon} key="Twitter">
        <ExternalLink href={shareUrl}>
          <TwitterIcon width={16} height={16} />
        </ExternalLink>
      </div>
    );
  };

  Line = t => {
    const currentUrl = encodeURIComponent(window.location.href);
    const shareUrl = `http://line.naver.jp/R/msg/text/?${encodeURIComponent(
      t('content.shareContent')
    )} ${currentUrl}`;

    return (
      <div className={styles.icon} key="Line">
        <ExternalLink href={shareUrl}>
          <LineIcon width={16} height={16} />
        </ExternalLink>
      </div>
    );
  };

  SocialIcons = {
    Facebook: this.Facebook,
    Email: this.Email,
    Twitter: this.Twitter,
    Line: this.Line,
  };

  renderIcons = socialNames => {
    const { t } = this.props;

    return socialNames.map(name => this.SocialIcons[name](t));
  };

  render() {
    const { socials } = this.props;

    return (
      <div className={styles.root}>
        <LikeBlock />
        <div className={styles.socialList}>{this.renderIcons(socials)}</div>
      </div>
    );
  }
}

export default compose(
  connect(mapStateToProps),
  translate(['content'])
)(SocialMedia);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/SocialMedia/SocialMedia.jsx